module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.fetchingStatus === 'fetching') ? _c('loader-large') : _vm._e(), _vm._v(" "), (_vm.postData && _vm.fetchingStatus === 'fetched') ? _c('feed-status-post', {
    key: _vm.postData.id,
    attrs: {
      "data": _vm.postData
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.postData && _vm.fetchingStatus === 'fetched') ? _c('div', {
    staticClass: "validation-messages error"
  }, [_vm._v("This post doesn't exist")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b4027728!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Developer/SubPages/DeveloperSinglePost.vue
// module id = 908
// module chunks = 2